module.exports = __webpack_public_path__ + "img/appQrcode_prod.f7642f5f.jpg";